import { IconHelp, Tooltip } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import styles from './PreviewContent.module.scss';

const cx = classNames.bind(styles);

export type ContentClassName =
  | 'preview-content-text'
  | 'preview-content-alphanumeric'
  | 'preview-content-numeric'
  | 'preview-content-date'
  | 'preview-content-pulldown';

export type Props = {
  contentClassName: ContentClassName;
  children: ReactNode;
  label?: string;
  tooltip?: string;
};

export const PreviewContentWrapper: FC<Props> = ({
  label,
  tooltip,
  contentClassName,
  children,
}) => {
  return (
    <div className={cx(styles['preview-content'], styles[contentClassName])}>
      <div className={cx(styles['preview-header'])}>
        <div className={cx(styles['preview-header-title'])}>
          <div
            className={cx(styles['preview-header-title-label'])}
            data-testid='preview-label'
          >
            {label || ''}
          </div>
          {tooltip ? (
            <Tooltip title={tooltip} placement='top'>
              <div data-testid='preview-icon-help'>
                <IconHelp size={14} />
              </div>
            </Tooltip>
          ) : null}
        </div>
      </div>
      <div className={cx(styles['preview-body'])}>{children}</div>
    </div>
  );
};

PreviewContentWrapper.displayName = 'PreviewContentWrapper';
